import * as types from './types'

export default {
  [types.NULL]: 'NULL',
  [types.HOME]: '首页',
  [types.DATA_OVERVIEW]: '数据总览',
  [types.LABEL_MARKET]: '标签集市',
  [types.CROWD_MANAGEMENT]: '人群管理',
  [types.CROWD_LIST]: '人群管理',
  [types.CROWD_ID]: '人群 ID',
  [types.LOOKALIKE_TOOL]: 'lookalike 工具',
  [types.CONFIGURE_CENTER]: '配置中心',
  [types.ORDER_TAG]: '订单标签组合',
  [types.E_COMMERCE_INSIGHT]: '电商标签每周流量洞察',
  [types.INQUIRY_MANAGE]: '问询管理',
  [types.INQUIRY_MANAGE_ORIGIN]: '问询源包',
  [types.INQUIRY_MANAGE_PUSH]: '推送列表',
  [types.INQUIRY_TASK]: '问询标签',
  [types.ALGORITHM_MODEL]: '算法模型',
  [types.TAG_CONFIG]: '标签配置',
  [types.APP_FLOW_QUERY]: 'APP流量查询',
  [types.PROJECT_TAG]: '项目标签',
  [types.SYNC_CONTROL]: '同步控制',
  [types.INQUIRY]: '问询 API',
  [types.INQUIRY_NAMAGE]: '问询管理',
  [types.TAG_PUBLISH]: '标签发布',
  [types.DNA]: 'DNA',
  [types.DMP]: '受众管理',
  [types.ALL]: '全部',
  [types.OVERALL]: '全部',
  [types.PERSON_LABEL]: '用户标签',
  [types.FAMILY_LABEL]: '家庭标签',
  [types.LABEL_STATUS]: '标签状态',
  [types.PERSON_LABEL_LIST]: '用户标签列表',
  [types.FAMILY_LABEL_LIST]: '家庭标签列表',
  [types.LABEL_CROWD]: '标签圈人',
  [types.UPLOAD_CROWD]: '自定义上传',
  [types.COMBINE_CROWD]: '组合人群',
  [types.LBS_CROWD]: 'LBS人群',
  [types.LBS_BATCH_ADDRESS]: '批量获取地址',
  [types.LOOKALIKE_CROWD]: 'lookalike人群',
  [types.BIDDEN_CROWD]: '投后人群',
  [types.ALGORITHM_CROWD]: '算法人群',
  [types.THIRDPARTDMP_CROWD]: '三方DMP人群',
  [types.COMPARE_CROWD]: '比较人群',

  [types.ALL_CROWD]: '全部人群',
  [types.MY_CROWD]: '我的人群',
  [types.CROWD_NAME]: '名称',
  [types.ORDER_NUMBER]: '序号',
  [types.EDIT_FORM_CROWD_NAME]: '人群名称',
  [types.EDIT_FORM_COMBINE_CONDITION]: '组合条件',
  [types.EDIT_FORM_DEFAULT_CONDITION]: '默认填充',
  [types.EDIT_FORM_DEFAULT_CONDITION_LAST]: '上一次',
  [types.EDIT_FORM_DEFAULT_CONDITION_NONE]: '无',
  [types.SEARCH_INPUT_PLACEHOLDER]: '请搜索您想要的标签，如：性别',
  [types.SEARCH_BUTTON]: '搜索',
  [types.TAG_EXPLAIN]: '标签体系说明',
  [types.HOT_WORD]: '热搜词',
  [types.ENTER_CROWD_CONDITION]: '加入人群条件',
  [types.TAG_NAME]: '标签名称',
  [types.COVERAGE_YOYI_ID]: '覆盖 YOYI ID',  
  [types.OPERATION]: '操作',
  [types.OPERATOR]: '操作者',
  [types.OPERATIONTIME]: '操作时间',
  [types.COVERAGE_YOYI_HHID]: '覆盖 Household ID 数',
  [types.PROPORTION]: '占比',
  [types.TAG_SEARCH_RESULT]: '标签搜索结果：全部标签 {keyword} 已筛选{total}个标签',
  [types.TAG_SEARCH_LABEL]: ' {typename}-{keyword} 标签： 共计 {total}个',

  [types.TAG_CLOUD]: '标签云',
  [types.ID_ATLAS]: 'ID 图谱',
  [types.ID_ATLAS_USER]: '用户',
  [types.ID_ATLAS_FAMILY]: '家庭',
  [types.OVERVIEW_TAG_CLOUD_CHART_INTRO]: 'DNA标签在地理位置，媒体偏好，消费偏好，消费场景每个维度YOYI ID覆盖量前100的叶子标签',
  [types.OVERVIEW_TAG_CLOUD_FAMILY_CHART_INTRO]: 'DNA家庭标签在媒体偏好，消费偏好，节目偏好，地理位置每个维度Household ID覆盖量前100的叶子标签',
  [types.OVERVIEW_ID_MAP_CHART_INTRO]: '各类型ID的数量以及相互拉通的数量关系图',
  [types.OVERVIEW_ID_MAP_FAMILY_CHART_INTRO]: '展示HouseholdID和其中可跨屏部分的数量情况',
  [types.OVERVIEW_INDUSTRY_CHART_INTRO]: '基于算法加工生成的各特征人群覆盖YOYIID数量',
  [types.OVERVIEW_AVERAGE_CHART_INTRO]: '使用箱型图展示YOYIID在每个维度覆盖标签数量分布情况',
  [types.OVERVIEW_AVERAGE_FAMILY_CHART_INTRO]: '使用箱型图展示HouseholdID在每个维度覆盖标签数量分布情况',
  [types.TERRITORY_DISTRIBUTE]: '地域分布',
  [types.TAG_DISTRIBUTE]: '标签分布',
  [types.INDUSTRY_CROWD]: '行业人群',
  [types.BASE_ATTRIBUTE]: '基础属性',
  [types.BASE_ATTRIBUTE_TOTAL]: '总数量',
  [types.GENDER]: '性别',
  [types.AGE]: '年龄',
  [types.AVERAGE_TAG_DISTRIBUTE]: '人均标签分布',
  [types.AVERAGE_FAMILY_TAG_DISTRIBUTE]: '家庭标签数量分布',
  [types.INTEREST]: '兴趣偏好',
  [types.INTEREST_FAMILY]: '家庭偏好',
  [types.INTEREST_INTERMEDIARY_HABIT]: '触媒习惯',
  [types.INTEREST_TERMINAL_BRAND]: '终端品牌',
  [types.RECENT_ID_TREND]: '近30天ID数量趋势',
  [types.RECENT_HOUSEHOLD_ID_TREND]: '近30天Household ID数量趋势',
  [types.FEMALE]: '女',
  [types.MALE]: '男',
  [types.BASE_INFO]: '基础信息',
  [types.POTENTIAL_CONSUMER_REQUEST]: '潜在消费需求',
  [types.HIGH]: '高',
  [types.LOW]: '低',
  [types.CHINA]: '全国',
  [types.BASE_SORT]: '基础分类',
  [types.COMMIT_DATE]: '提交日期',
  [types.NO_MORE_THAN_60]: '时间周期最长支持60天',
  [types.END_LIMIT_WITH_TODAY]: '结束日期不能超过今天',
  [types.CREATE_SUCCESS]: '创建成功',
  [types.PLEASE_INPUT_CROWD_NAME]: '请填写人群名称',
  [types.PLEASE_INPUT_PLACE_NAME]: '请输入地方名称',
  [types.PLEASE_INPUT_FTP_PATH]: '请输入 FTP 路径',
  [types.AD_EMPLOYER]: '广告主',
  [types.PROJECT]: '项目',
  [types.CHANNEL]: '渠道',
  [types.PLEASE_SELECT_FILES]:'请选择文件',
  [types.PLEASE_SELECT_FILE]:'请选择文件',
  [types.PLEASE_SELECT_PROJECT]:'请选择项目',
  [types.PLEASE_SELECT_TAGS]: '请选择标签',
  [types.PLEASE_SELECT_SEGMENTS]: '请选择人群',
  [types.PLEASE_SELECT_SEGMENT]: '请选择人群',
  [types.PLEASE_SELECT_API]: '请选择 API',
  [types.PLAN]: '计划',
  [types.PLEASE_SELECT_PLAN]: '请选择计划',
  [types.ORDER]: '订单',
  [types.CREATIVITY]: '创意',
  [types.CYCLE]: '时间周期',
  [types.PLEASE_SELECT_CYCLE]: '请选择时间周期',
  [types.BEHAVIOR_CONDITION]: '转化',
  [types.BEHAVIOR_TYPE]: '转换类型',
  [types.FREQUENCY]: '频次',
  [types.UNLIMITED]: '不限',
  [types.MORE_THAN_TWO_TIMES]: '3次及以上',
  [types.MORE_THAN_FIVE_TIMES]: '6次及以上',
  [types.CUSTOM]: '自定义',
  [types.CI_JI_YI_SHANG]: '次及以上',
  [types.TERMINAL_TYPE]: '终端类型',
  [types.SYSTEM_TYPE]: '系统类型',
  [types.CREATE]: '创建',
  [types.CANCEL]: '取消',
  [types.COMBINE_CONDITION]: '组合条件',
  [types.COMMIT]: '提交',
  [types.COMBINE_RESULT]: '组合结果',
  [types.DATA_NOT_AVAILABLE]: '暂无数据',
  [types.RESET]: '重置',
  [types.SEQUENCE]: '序号',
  [types.COVERAGE_USER]: '数量',
  [types.COVERAGE_UPLOAD]: '数量',
  [types.TYPE]: '类型',
  [types.MOST_20_PERSON]: '最多选择20个人群包进行组合',
  [types.MOST_2_SEGMENT_COMPARE]: '最多选择2个人群包进行对比',
  [types.TOTAL]: '共 {total} 条',
  [types.PLEASE_UPLOAD_FILE]: '请上传文件!',
  [types.PLEASE_UPLOAD_EXCEL]: '请上传Excel文件!',
  [types.FILE_COUNT_MOST_1]: '最多上传1个文件!',
  [types.ONLY_EXCEL_CSV_TXT]: '只支持 excel, csv, txt',
  [types.FILE_SIZE_LESS_THAN_1G]: '文件最大1G!',
  [types.FILE_SIZE_LESS_THAN_6G]: '文件最大6G!',
  [types.RANGE_TIP]: '开始范围不能大于结束范围!',
  [types.UPLOAD_SUCCESS]: '上传成功',
  [types.CREATE_CROWD]: '创建人群',
  [types.EDIT_CROWD]: '编辑人群',
  [types.CROWD_DEFINATION]: '人群定义',
  [types.ADD_TO_SEGMENT]: '加入人群条件',
  [types.DOWNLOAD_TEMPLATE]: '下载模板',
  [types.FILE_SIZE_ATTENTION]: '注意:上传文件最大支持1G',
  [types.INPUT_TOO_LONG]: '输入字符过长',
  [types.UPLOAD]: '上传文件',
  [types.UPLOAD_FILE]: '上传文件',
  [types.SELECT_FILE]: '选择文件',
  [types.SUPPORT_CSV_TXT]: '支持 csv, txt',
  [types.SUPPORT_EXCEL_CSV_TXT]: '支持 xls, xlsx, csv, txt',
  [types.CROWD_FILE_NAME]: '人群包文件名称',
  [types.ID_TYPE]: 'ID类型',
  [types.ID_SIGN]: 'ID标识',
  [types.SELECT_ID_TYPE]: '选择ID类型',
  [types.THIRD_PARTY]: '第三方',
  [types.THIRD_PARTY_COOKIE]: '第三方 cookie',
  [types.COOKIE]: 'Cookie',
  [types.TOTAL_USER]: '总用户量',
  [types.STATUS]: '状态',
  [types.YOYI_MATCHING_RATIO]: '匹配率',
  [types.MAINTAIN_DATE]: '维护日期',
  [types.INVALID_DATE]: '失效日期',
  [types.CREATOR]: '创建人',
  [types.SEARCH_WITH_CROWD_NAME]: '按人群包名称搜索',
  [types.PROCESS_FILE_TIME]: '每个文件匹配需1.5小时，请您耐心等待，计算完成时间与提交文件的多少有关。',
  [types.CROWD_NAME_OBSCURE_SEARCH]: '人群名称模糊搜索',
  [types.DELAY_SUCCESS]: '延期成功',
  [types.DELAY]: '延期',
  [types.CONFIRM]: '确认',
  [types.CREATE_TIME]: '创建时间',
  [types.INVALID_TIME]: '失效时间',
  [types.SET_DELAY]: '设置延期',
  [types.DELAY_UNTIL]: '延期至',
  [types.SPREAD_SUCCESS]: '扩散成功',
  [types.SPREAD_CROWD]: '扩散人群',
  [types.SPREAD]: '扩散',
  [types.CROWD_PACKAGE]: '人群包',
  [types.LOOK_LIKE_NAME]: 'lookalike名称',
  [types.PLEASE_INPUT_SPREAD_CROWD_NAME]: '请输入扩散后人群名称',
  [types.CROWD_SPREAD_CONDITION]: '人群扩散条件',
  [types.PLEASE_SELECT_SPREAD_CROWD_CONDITION]: '请选择人群扩散条件',
  [types.ONLY_UNLIMITED_SPREAD_CONDITION]: '选择了不限，不能再选其它扩散条件',
  [types.CROWD_SPREAD_TIMES]: '人群扩散倍数',
  [types.PLEASE_INPUT_SPREAD_TIMES]: '请填写扩散倍数',
  [types.SPREAD_TIMES_1_10]: '扩散倍数1~10倍',
  [types.TIMES]: '倍',
  [types.TIMES_]: '次',
  [types.START_LATE_END]: '开始时间晚于结束时间',
  [types.CAN_NOT_SYNC_WITHOUT_AD_EMPLOYER]: '没有广告主信息，不能同步',
  [types.SYNC_PLUS_SUCCESS]: '同步 plus 成功',
  [types.SYNC_PLATFORM_SUCCESS]: '同步直投平台成功',
  [types.MY_AD_EMPLOYER]: '我的广告主',
  [types.GET_AD_EMPLOYER_FAIL]: '获取广告主失败',
  [types.SYNC_PLUS]: '同步plus',
  [types.SYNC_PLATFORM]: '同步直投平台',
  [types.SYNC_THIRD]: '同步三方问询',
  [types.SELECT_AD_EMPLOYER]: '选择广告主',
  [types.PLEASE_SELECT_AD_EMPLOYER]: '请选择广告主',
  [types.START_TIME]: '开始时间',
  [types.PLEASE_SELECT_START_TIME]: '请选择开始时间',
  [types.START_DATE]: '开始日期',
  [types.END_TIME]: '结束时间',
  [types.PLEASE_SELECT_END_TIME]: '请选择结束时间',
  [types.END_DATE]: '结束日期',
  [types.CLEAR]: '清空',
  [types.START_COMBINE]: '开始组合',
  [types.START_COMPARE]: '开始对比',
  [types.CURRENT_STATUS_COUNT]: '当前状态数量',
  [types.CROWD_TOTAL]: '人群总数',
  [types.CROWD_TYPE]: '人群类型',
  [types.ALL_STATUS]: '全部状态',
  [types.ALL_TYPES]: '全部类型',
  [types.CROWD_PACKAGE_AUTO_UPDATE]: '人群包自动更新',
  [types.TASK_NO_START_PLEASE_WAIT]: '任务暂未开始，请稍后再试',
  [types.CREATE_CROWD_PACKAGE_PLEASE_WAIT]: '正在生成人群包，请稍后再试',
  [types.SYNC_CROWD_PACKAGE_PLEASE_WAIT]: '人群包正在同步中，请稍后再试',
  [types.CROWD_PACKAGE_OUTDATE_CAN_NOT_AUTO_UPDATE]: '人群包已失效，不支持自动更新',
  [types.MODIFY_AUTO_UPDATE_STATUS]: '修改自动更新状态为',
  [types.AUTO_UPDATE]: '自动更新',
  [types.NO_AUTO_UPDATE]: '非自动更新',
  [types.UPDATE_SUCCESS]: '修改成功',
  [types.CROWD_PACKAGE_ADDED]: '人群包已添加',
  [types.MAKING_CROWD_PACKAGE_PLEASE_WAIT]: '正在生成人群包，请稍后再试',
  [types.UNSUPPORTED_COMBINE_WITHOUT_LOOKALIKE]: '未生成 lookalike，不支持组合',
  [types.UNSUPPORTED_COMBINE_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不支持组合',
  [types.UNSUPPORTED_DELAY_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不支持延期',
  [types._DELETE]: '删除',
  [types.CAN_NOT_DELETE_WHEN_MAKING_CROWD_PACKAGE]: '正在生成人群包，不可删除',
  [types.CAN_NOT_DELETE_WHEN_SYNCING_CROWD_PACKAGE]: '正在同步人群包，不可删除',
  [types.CAN_NOT_DELETE_AFTER_CROWD_PACKAGE_SYNC_PLUS]: '人群包已同步到PLUS，不可删除',
  [types.CAN_NOT_DELETE_DMP_CROWD_PACKAGE]: 'DMP 人群包不能删除',
  [types.SURE_TO_DELETE_CROWD_XXX]: '确定删除人群: {name} ?',
  [types.NEW_TYPE_CROWD_WITHOUT_CONFIGURED]: '新类型人群，没有进行配置',
  [types.DELETE_SUCCESS]: '删除成功',
  [types.EDIT]: '编辑',
  [types.DOWNLOAD]: '下载',
  [types.COPY]: '复制',
  [types.CHECK]: '检查',
  [types.CAN_NOT_EDIT_WHEN_SYNCING_CROWD_PACKAGE]: '正在同步人群包，不支持编辑',
  [types.CAN_NOT_EDIT_WHEN_CROWD_PACKAGE_SYNCED_PLUS]: '人群包已同步到PLUS，不支持编辑',
  [types.CAN_NOT_EDIT_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不支持编辑',
  [types.CAN_NOT_EDIT_WITH_FUZZY_SEARCH_LBS]: '模糊搜索生成的LBS，不支持编辑',
  [types.CROWD_INSIGHT]: '人群洞察',
  [types.CROWD_INSIGHT_OVERVIEW]: '概览画像',
  [types.AD_TRAFFIC]: '流量洞察',
  [types.CROWD_FLOW_INSIGHT]: '流量洞察',
  [types.MAKING_INSIGHT_PLEASE_TRY_LATER]: '正在生成洞察，请稍后再试',
  [types.CAN_NOT_INSIGHT_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不能进行洞察',
  [types.PLEASE_SELECT_ID_TYPE]: '请先选择ID类型',
  [types.INSIGHT_MUST_WITH_MORE_THAN_500_PERSON]: '人数少于500不能进行洞察',
  [types.CAN_NOT_SPREAD_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不支持扩散',
  [types.CAN_NOT_SPREAD_CROWD_PACKAGE_500_UNTIL_MILLION]: '人数少于500或大于100万不能进行扩散',
  [types.SYNC]: '同步',
  [types.SYNCING_PLEASE_WAIT]: '正在同步，请稍后',
  [types.SYNCING_CROWD_PACKAGE_PLEASE_WAIT]: '正在同步人群包，请耐心等待',
  [types.CAN_NOT_SYNC_WITHOUT_VALID_CROWD_PACKAGE]: '人群包已失效，不支持同步',
  [types.NO_MATCHING_CROWD]: '无匹配人群',
  [types.SYNC_SUCCESS]: '同步成功',
  [types.GO_TO_DATA_CRYSTAL_PLATFORM]: '请前往 Data Crystal 平台查看',
  [types.ADVANCE]: '前往',
  [types.NO_VALID_CROWD]: '没有即将失效人群',
  [types.USED]: '已经使用',
  [types.CROWD_UPPER_LIMIT]: '人群上限',
  [types.TO_BE_INVALIDATE]: '即将失效',
  [types.SELECT_GRANT_CROWD]: '选择人群授权',
  [types.SHOW_TO_AGENT]: '代理商下账户可见',
  [types.SHOW_TO_ALL_USER]: '全部用户可见',
  [types.AT_LEAST_A_CROWD]: '最少需要一个人群授权，默认仅创建人可见!',
  [types.ABS_VALUE]: '绝对值',
  [types.TGI_VALUE]: 'TGI',
  [types.CROWD_PACKAGE_PROPORTION]: '占人群包比重',
  [types.TGI_INDEX]: 'TGI指数',
  [types.CROWD_COUNT]: '人群数量',
  [types.POPULATION_ATTRIBUTE]: '人口属性',
  [types.CONSUME_SCENE]: '消费场景',
  [types.CONSUME_SCENE_SHORT]: '消费场景',
  [types.ONLINE_CHARACTER]: '上网特征',
  [types.APP_CATEGORY]: 'APP类别',
  [types.DISTINGUISH_FEATURE]: 'TOP50 显著特征',
  [types.GENDER_DISTRIBUTE]: '性别分布',
  [types.AGE_DISTRIBUTE]: '年龄分布',
  [types.PROGRAM_PREFERENCE]: '节目偏好',
  [types.MEDIA_PREFERENCE]: '媒体偏好',
  [types.CONSUME_PREFERENCE]: '消费偏好',
  [types.SHOPPING_PREFERENCE]: '购物倾向',
  [types.SAVE_PAGE_AS_PICTURE]: '保存本页为图片',
  [types.INSIGHT_REPORT_DOWNLOAD]: '“人群洞察报告”下载',
  [types.PERSONAL_PORTRAY_DOWNLOAD]: '个人画像下载',
  [types.ACTIVE_PERSON_RECENT_15_DAYS]: '最近半个月活跃人数',
  [types.ACTIVE_PERSON_RECENT_30_DAYS]: '最近一个月活跃人数',
  [types.ACTIVE_PERSON_RECENT_60_DAYS]: '最近两个月活跃人数',
  [types.SELECT_CONDITION_NONE]: '选择条件: 无',
  [types.SELECT_CONDITION]: '条件',
  [types.LOOKALIKE_SELECT_CONDITION]: '条件',
  [types.SELECT_TIME]: '时间选择',
  [types.SELECTED_RANGE]: '所选范围',
  [types.ADDRESS]: '地址',
  [types.SPREAD_CONDITION]: '扩散条件',
  [types.SEED_CROWD_COUNT]: '种子人群数',
  [types.SPREAD_CROWD_COUNT]: '扩散人群数',
  [types.TO_BE_INVALIDATE_CROWD_PACKAGE_COUNT]: '即将失效人群包: {total} 个',
  [types.SEARCH_TAG]: '搜索标签',
  [types.MATCH_TAG]: '匹配标签',
  [types.SELECTED_TAG]: '已选标签',
  [types.TAG_LIST]: '标签列表',
  [types.CROWD_IS_CREATING_PLEASE_WAIT]: '人群正在创建请稍后',
  [types.CONDITION_COMBINE_ERROR]: '条件组合错误',
  [types.NAME_LENGTH_NO_MORE_THAN_20]: '名称长度不能超过20',
  [types.LOOK_COVERAGE_CROWD]: '查看覆盖人群',
  [types.SAVE_SUCCESS]: '保存成功',
  [types.SAVE]: '保存',
  [types.PLEASE_INPUT_MATCH_CONTENT]: '请输入匹配内容，如: "男,智能穿戴"',
  [types.DEFAULT_CONDITION]: '默认条件',
  [types.UNMATCHED_TAG]: '未匹配标签',
  [types.EXIST_TAG]: '已存在标签',
  [types.PLEASE_INPUT_SEARCH_CONTENT]: '请输入搜索内容',
  [types.PLEASE_INPUT_SEARCH_CONDITION]: '请输入搜索条件',
  [types.SEARCH_CONDITION]: '搜索条件',  
  [types.PLEASE_INPUT_TAG_NAME]: '请输入标签名称',
  [types.AND]: '交',
  [types.OR]: '并',
  [types.NOT]: '非',
  [types.MINUS]: '减',
  [types.LEFT_PARENTHESIS]: '(',
  [types.RIGHT_PARENTHESIS]: ')',
  [types.PLEASE_CONFIG_TAG_COMBINE]: '请配置标签组合',
  [types.SQL_START_REQUEST]: '开始不能是符号，若是符号必须是"("或"非"',
  [types.SQL_NOT_SYMBOL_REQUEST]: '"非"前必须有符号',
  [types.SQL_LEFT_BRACKET_REQUEST]: '"("前不能为标签或者")"',
  [types.ATTENTION_SYMBOL_SPACE]: '请注意标签符号间隔',
  [types.SQL_RIGHT_BRACKET_REQUEST]: '")"后面必须是符号',
  [types.CAN_ONLY_END_WITH_RIGHT_BRACKET]: '不能以非")"符号作为结束',
  [types.BRACKET_NOT_MATCH]: '括号不匹配',
  [types.NOT_SYMBOL_MUST_AFTER_AND_OR]: '‘非’前需要有‘交’或者‘并’',
  [types.CREATING]: '生成中',
  [types.SPREADING]: '扩散中',
  [types.PLEASE_SELECT_POSITION]: '请至少选择一个位置',
  [types.PLEASE_SET_DISTANCE_0_5_KM]: '请设置距离为 0-5km',
  [types.PLEASE_CONFIRM_DISTANCE_ORDER]: '请确认范围大小顺序',
  [types.EDIT_CROWD_SUCCESS]: '编辑人群成功',
  [types.CREAT_CROWD_SUCCESS]: '新建人群成功',
  [types.EDIT_CROWD_NAME_SUCCESS]: '编辑人群名称成功',
  [types.CROWD_NO_UPDATE]: '人群没有修改',
  [types.PLEASE_INPUT_NO_MORE_THAN_20_LENGTH_CROWD_NAME]: '请输入20字以内人群名称',
  [types.SELECT_RESULT]: '已选结果',
  [types.NATIONWIDE]: '全国',
  [types.TELEPHONE]: '电话',
  [types.NOT_NATCH_LONGITUDE_AND_LATITUDE]: '没有匹配到经纬度',
  [types.SEARCH_LONGITUDE_AND_LATITUDE]: '搜经纬度、查地点、找门店名',
  [types.BATCH_SEARCH]: '批量搜索',
  [types.BATCH_SEARCH_SHORT]: '批量搜索',
  [types.FILTER_CITY]: '筛选城市',
  [types.CHECK_ALL_THIS_PAGE]: '本页全选',
  [types.ESTIMATE_PERSON]: '预估人数',
  [types.PLEASE_SELECT_SEARCH_RESULT]: '请选择搜索结果',
  [types.PLEASE_INPUT_CORRECT_NUM]: '请输入正确数字',
  [types.CUSTOM_RANGE_IN_0_5_KM]: '自定义范围在0km-5km之间',
  [types.START_RANGE_LESS_THAN_END_RANGE]: '开始范围不能大于结束范围',
  [types.CUSTOM_RANGE_CONTAIN_2_DECIMAL]: '自定义范围小数最多保留两位数',
  [types.LBS_NAME]: 'LBS 名称',
  [types.BATCH_CREATE]: '批量创建',
  [types.LBS_QUAN_REN]: 'LBS圈人',
  [types.ENTER_LBS_SEARCH]: '进入LBS搜索',
  [types.WAIT_LBS_SEARCH_PER_ONE_AND_A_HALF_HOUR]: '每个LBS信息查询用户数需要1.5小时，请您耐心等待，计算完成时间与提交LBS信息的多少有关',
  [types.SEED_COUNT]: '种子包数量',
  [types.DIFFUSE_COUNT]: '数量',
  [types.SPREAD_TIMES]: '人群扩散倍数',
  [types.SEED_CROWD_NAME]: '种子包名称',
  [types.CROWD_AUTH]: '已授权对象',
  
  [types.PC]: 'PC',
  [types.MOBILE]: 'Mobile',
  [types.OTT]: 'OTT',
  [types.TV]: 'TV',
  [types.IOS]: 'iOS',
  [types.ANDROID]: 'Android',
  [types.YOYI_COOKIE]: 'YOYI Cookie',
  [types.IDFA_IMEI]: 'IDFA & IMEI',
  // options
  [types.STATUS_CREATED]: '已创建',
  [types.STATUS_GENERATING]: '生成中',
  [types.STATUS_GENERATED]: '已生成',
  [types.STATUS_SYNCHRONIZING]: '同步中',
  [types.STATUS_SYNCHRONIZED]: '已同步',
  [types.STATUS_EXPIRED]: '已失效',
  [types.STATUS_DELETE]: '已删除',
  [types.STATUS_MATCH_COUNT_LESS]: '匹配数量小于500',

  [types.LBS_UPLOAD_CREATE_NOTICE]: '注意：文件格式为：店名、地理位置、所在城市',
  [types.LBS_SEARCH_CREATE_NOTICE]: '注意：如果支持的LBS较多，输出结果可能需要48小时以上，还请谨慎提交并耐心等待',
  [types.SUPPORT]: '支持',
  
  [types.LOGOUT]: '退出登录',
  [types.ACCOUNT_MANAGEMENT]: '账号管理',
  [types.ROLE_MANAGEMENT]: '角色管理',
  [types.FINANCE_MANAGEMENT]: '财务管理',
  [types.MODIFY_PASSWORD]: '修改密码',
  [types.USER_MANAGEMENT]: '客户管理',
  [types.AGENT_MANAGEMENT]: '代理商管理',
  [types.DATA_MANAGEMENT]: '数据管理',
  [types.MORE_FUNCTION]: '更多功能',
  [types.DEVICE_ORIGIN]: 'Device来源',

  [types.UPPER_BOUND]: '上界',
  [types.UPPER_QUARTILE]: '上四分位',
  [types.MIDDLE_QUARTILE]: '中四分位',
  [types.LOWER_QUARTILE]: '下四分位',
  [types.LOWER_BOUND]: '下界',
  [types.AVERAGE]: '均值',

  [types.BEIJING]: '北京市',
  [types.TIANJIN]: '天津市',
  [types.SHANGHAI]: '上海市',
  [types.CHONGQING]: '重庆市',
  [types.HEBEI]: '河北省',
  [types.SHANXI]: '山西省',
  [types.LIAONING]: '辽宁省',
  [types.JILIN]: '吉林省',
  [types.HEILONGJIANG]: '黑龙江省',
  [types.JIANGSU]: '江苏省',
  [types.ZHEJIANG]: '浙江省',
  [types.ANHUI]: '安徽省',
  [types.FUJIAN]: '福建省',
  [types.JIANGXI]: '江西省',
  [types.SHANDONG]: '山东省',
  [types.HENAN]: '河南省',
  [types.HUBEI]: '湖北省',
  [types.HUNAN]: '湖南省',
  [types.GUANGDONG]: '广东省',
  [types.HAINAN]: '海南省',
  [types.SICHUAN]: '四川省',
  [types.GUIZHOU]: '贵州省',
  [types.YUNNAN]: '云南省',
  [types.SHAANXI]: '陕西省',
  [types.GANSU]: '甘肃省',
  [types.QINGHAI]: '青海省',
  [types.TAIWAN]: '台湾省',
  [types.NEIMENGGU]: '内蒙古自治区',
  [types.GUANGXI]: '广西壮族自治区',
  [types.XIZANG]: '西藏自治区',
  [types.NINGXIA]: '宁夏回族自治区',
  [types.XINJIANG]: '新疆维吾尔自治区',
  [types.XIANGGANG]: '香港特别行政区',
  [types.AOMEN]: '澳门特别行政区',
  [types.TAG_COMBINATION]: '选择条件',
  [types.IMPRESSION]: '曝光',
  [types.CLICK]: '点击',
  [types.IMPRESSION_NOT_CLICK]: '曝光未点击',
  [types.CLICK_NOT_CONVERSION]: '点击未转化',
  [types.SWITCH_OPEN]: '开',
  [types.SWITCH_CLOSE]: '关',
  [types.SWITCH_YES]: '是',
  [types.SWITCH_NO]: '否',
  [types.GENERATE_EACH_LBS_TO_SEGMENT]: '生成LBS子包',
  [types.LBS_SWITCH_TIP]: '开启此开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包',
  [types.GENERATE_INSIGHT]: '是否生成洞察',
  [types.MATCH_INSIGHT]: '是否匹配洞察',
  [types.UPLOAD_CROWD_NOTE]: '上传须知',
  [types.UPLOAD_CROWD_TIP1]: '1. 上传文件最大支持1G，如需上传大于1G的文件，请联系管理员。',
  [types.UPLOAD_CROWD_TIP2]: '2. 上传文件支持格式：xls,xlsx,csv,txt，仅识别文件的第一列数据。',
  [types.UPLOAD_CROWD_TIP3]: '3. 上传目的：上传创建完成后不会产生洞察，可立即设置同步。', // 无论是否生成洞察，同步的ID都是上传的原始文件的所有ID(cookie除外)。',
  [types.UPLOAD_CROWD_TIP4]: '4. 为了不影响投放时间，请至少提前一天进行人群包上传,创建,并点击同步，直至同步完成。',
  [types.BIDDEN_CROWD_NOTE]: '创建须知',
  [types.BIDDEN_CROWD_TIP1]: '1. 时间周期最长支持选择两个月',
  [types.BIDDEN_CROWD_TIP2]: '2. 自定义频次区间为左闭右开；比如设置1-6，则计算 1<=频次<6的数据',
  [types.BIDDEN_CROWD_TIP3]: '3. 上传文件支持xlsx，xls格式',
  [types.BIDDEN_CROWD_TIP4]: '4. 单个文件最多支持20行，即一次最多支持批量创建20个人群',
  [types.BIDDEN_CROWD_TIP5]: '5. 单个人群支持最多200个订单/项目/计划ID',
  [types.BIDDEN_CROWD_TIP6]: '6. 上传文件后需先进行校验，系统将校验所填订单/项目/计划ID是否存在于所选广告主下，请校验通过后再进行创建',
  [types.LBS_CROWD_NOTE]: '创建须知',
  [types.LBS_CROWD_TIP1]: '1. 开启生成LBS子包开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包；如无特殊需求建议关闭',
  [types.LBS_CROWD_TIP2]: '2. 周边范围区间为左开右闭；比如设置1~5KM，则计算1<周边半径<=5的数据',
  [types.LBS_CROWD_TIP3]: '3. 上传文件格式支持xls,xlsx',
  [types.LBS_CROWD_TIP4]: '4. 上传文件需包含三列信息：地名、详细地址和所在城市。详见模板',
  [types.BOXPLOT_OUTLINER_UP_COUNT]: '离群值数量',
  [types.BOXPLOT_OUTLINER_UP_RATE]: '离群值比例',
  [types.BOXPLOT_OUTLINER_DOWN_COUNT]: '离群值数量',
  [types.BOXPLOT_OUTLINER_DOWN_RATE]: '离群值比例',
  [types.INQUIRY_CREATE]: '创建问询API',
  [types.INQUIRY_EDIT]: '编辑问询API',
  [types.INQUIRY_API_NAME]: 'API名称',
  [types.INQUIRY_JAR_PACKAGE_PATH]: 'JAR包路径',
  [types.INQUIRY_API_DESC]: 'API描述',
  [types.INQUIRY_PLEASE_INPUT_API_NAME]: '请输入API名称',
  [types.INQUIRY_PLEASE_INPUT_JAR_PACKAGE_PATH]: '请输入JAR包路径',
  [types.INQUIRY_PLEASE_INPUT_API_DESC]: '请对API支持的功能进行描述',

  [types.SOURCE_CROWD_TYPE]: '源人群类型',
  [types.SOURCE_CROWD_PACKAGE]: '源人群包',
  [types.INQUIRY_2TIMES_PACKAGE]: '2+次问询包',
  [types.DAILY_INQUIRY_TIME]: '日问询时间',
  [types.OCLOCK]: '时',
  [types.SOURCE_PACKAGE]: '源包',
  [types.NEW_PACKAGE]: '新包',
  [types.SOURCE_PACKAGE_NEW_PACKAGE]: '源包+新包',
  [types.FTP_PATH]: 'FTP 路径',
  [types.ORIGIN_SEGMENT_TYPE]: '源包类型',
  [types.CREATE_MAP_CREATE]: '地图创建',
  [types.CREATE_UPLOAD_CREATE]: '上传创建',

  [types.SYNC_PLUS_START_DATE_TIP]: '同步开始日期是开始把人群数据同步到PLUS投放系统中的时间，建议选择投放开始前一天',
  [types.SYNC_PLUS_END_DATE_TIP]: '同步结束日期后一天人群数据在PLUS投放系统中不再可用，建议选择投放结束当天',
  [types.SYNC_PLUS_SWITCH_TIP]: '开启此开关将会每天更新人群覆盖ID数据；关闭此开关将不会更新',
  [types.SYNC_PLATFORM_START_DATE_TIP]: '同步开始日期是开始把人群数据同步到直投平台中的时间，建议选择投放开始前一天',
  [types.SYNC_PLATFORM_END_DATE_TIP]: '同步结束日期后一天人群数据在直投平台中不再可用，建议选择投放结束当天',
  [types.SEGMENT_DOWNLOAD]: '人群下载',
  [types.SEGMENT_COMPARE]: '人群对比',
  [types.CUSTOM_LABEL]: '标签状态',
  [types.CUSTOM_LABEL_SELF]: '自定义标签',
  [types.CUSTOM_LABEL_USER]: '用户标签',
  [types.CUSTOM_LABEL_FAMILY]: '家庭标签',
  [types.CROWD_INVALID]: '失效人群',

  [types.PERSON]: '个人',
  [types.FAMILY]: '家庭',
  [types.SEGMENT_PERSON]: '个体人群',
  [types.SEGMENT_FAMILY]: '家庭群体',
  [types.BACK_LAST_LEVEL]: '返回上级',

  [types.FAMILY_INSIGHT_OVERVIEW]: '家庭画像',
  [types.FAMILY_PROPERTY]: '家庭属性',
  [types.FAMILY_STRUCTURE]: '家庭结构',
  [types.FAMILY_AGE]: '成员年龄',
  [types.FAMILY_GENDER]: '成员性别',
  [types.TV_BRAND]: '电视品牌',
  [types.CROSS_NUMBER]: '跨屏数量',
  [types.RESULT_DOWNLOAD]: '结果下载',
  [types.RESULT_DOWNLOAD_TIP]: '下载数量超出系统上限，请分城市下载结果',

  [types.CROWD_CONVERSE]: '人群转换',
  [types.CONVERSE_CROWD]: '转换人群',
  [types.ORIGIN_SEGMENT_NAME]:'源包名称',
  [types.ORIGIN_SEGMENT_ID_TYPE]:'源包ID类型',
  [types.NAME]: '名称',
  [types.SYNC_OVER_TIP]: '当前人群量级过大超出系统同步最大量级限制，可能造成同步任务延迟，请您检查人群创建条件是否正常。如需继续同步需要管理员审核，审核通过后人群将正常同步。是否继续提交？',

  [types.REPORT]: '统计报表',
  [types.REPORT_SEGMENT]: '人群报表',
  [types.DATA_TYPE]: '数据类型',
  [types.GEO]: '地理位置',

  [types.FAMILY_STRUCTURE_SINGLE]: '单身/单独居住',
  [types.FAMILY_STRUCTURE_COUPLE]: '二人世界',
  [types.FAMILY_STRUCTURE_CHILDREN]: '育儿家庭',
  [types.FAMILY_STRUCTURE_THREE]: '三代同堂',

  [types.USER]: '用户',

  [types.THIRD_PARTY_INQUIRY]: '三方问询',
  [types.PROJECT_MANAGEMENT]: '项目管理',
  [types.DATA_REPORT]: '数据报表',
  [types.INQUIRY_START]: '问询开始',
  [types.INQUIRY_DOING]: '问询中',
  [types.INQUIRY_DONE]: '问询完成',


  [types.DNA_COPY_CROWD]: 'DNA复制人群',
  [types.TRAFFIC_CROWD]: '流量圈人',
  [types.SPLIT_CROWD]: '人群包拆分',
  [types.CROWD_EFFECT]: '效果定制人群',
  [types.ACTIVE_CROWD]: '活动人群',
  
  [types.IDFA]: 'IDFA',
  [types.IDFA_MD5]: 'IDFA MD5加密',
  [types.IMEI]: 'IMEI',
  [types.IMEI_MD5]: 'IMEI MD5加密',
  [types.ANDROIDID]: 'Android ID',
  [types.ANDROIDID_MD5]: 'Android ID MD5加密',
  [types.OAID]: 'OAID',
  [types.OAID_MD5]: 'OAID MD5加密',
  [types.FTP_MANAGE]: 'FTP 管理',
  [types.PLATFORM_MANAGE]: '平台管理',
  [types.ABSOLUTE_TIME]: '绝对时间',
  [types.RELATIVE_TIME]: '相对时间',
  
}